import React from "react";

const Diliver = () =>{
    
    return(
    <>
    <div className="container my-5">
    <div className ="container-xl col-md-8" style = {{height:"90vh"}}>
    <div className = "text-center">
        <h2 style={{color: "SteelBlue"}}>Thank you for shopping with Jet Ecommerce.</h2>
        <h3>This is your order number : 238530 </h3>
        <hr></hr>
        <img src ={"https://jungleworks.com/wp-content/uploads/2021/08/Online_Shoping_29-1024x819.jpg"} alt="Logo" height="280px"/>
    </div>
    </div>
    </div>
    </>
)
}

export default Diliver